
/* injects from baggage-loader */

'use strict';

import AccountSettingsPaymentsController from './account.settings.payments.controller';
import AccountSettingsPaymentsTemplate from './account.settings.payments.html';

export default class AccountSettingsPaymentsComponent {
	constructor() {
		this.templateUrl = AccountSettingsPaymentsTemplate;
		this.controller = AccountSettingsPaymentsController;
		this.controllerAs = 'ctrl';
		// Bind resolved items to the controller, see module state for resolve
		this.bindings = {
			stripeAccount: '<'
		};
	}
}



// WEBPACK FOOTER //
// ./src/app/pages/account/settings/payments/account.settings.payments.component.js